import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import About from "../components/About";
import Footer from "../components/Footer";

function App() {
  return (
    <div className="site-root">
        <Header />
        <main>
          <Hero />
          <HowItWorks />
          <Features />
          <About />
          
        </main>
        <Footer />
      
    </div>
  );
}
export default App;